import React from "react";
import ReactDOM from "react-dom";

import { observer, inject, Provider } from "mobx-react";

import { extendObservable } from 'mobx';


@inject('core')
@observer
export default class NeedButton extends React.Component {
	
	componentDidMount() {
		const { core } = this.props
		
		this.changeNeeds = this.changeNeeds.bind(this)
	}
	
	changeNeeds(product_id, change_delta) {
		const { core } = this.props

		core.action({ op: 'setNeeds', product_id: product_id, needs: core.products.find( p => p.product_id == product_id ).needs + change_delta })
	}

	render() {
		const { core, product_id } = this.props
		
		const product = core.products.find(p => p.product_id == product_id)
		if (typeof product === 'undefined') {
			return <div>Unknown Product</div>
		}
		
		return [
			<span key="need-inc" className="needs-button-inc clickable needs-stepper" onClick={() => this.changeNeeds(product.product_id, +1)}>+</span> ,
			<span key="need-dec" className="needs-button-dec clickable needs-stepper" onClick={() => this.changeNeeds(product.product_id, -1)}>-</span>
		]
	}
	
}


